import { LinearProgress } from "@mui/material";
import { useRouter } from "next/router";
import React, { useState } from "react";

export const Loader = () => {
  const router = useRouter();
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);

  React.useEffect(() => {
    const handleRouteChange = (url, { shallow }) => {
      setIsLoaderVisible(true);
    };

    const handleRouteComplete = (url, { shallow }) => {
      setIsLoaderVisible(false);
    //   setDirty(false);
    };

    router.events.on("routeChangeStart", handleRouteChange);
    router.events.on("routeChangeComplete", handleRouteComplete);

    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
      router.events.off("routeChangeComplete", handleRouteComplete);
    };
  }, []);

  if (isLoaderVisible) {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          display: "flex",
          justifyContent: "center",
          // alignItems: "center",
          background:' #211f1f',
          opacity: 0.8,
          zIndex:999,
          width:"100%",

        }}
      >
        <div style={{width: '100%',marginBottom:"250px",marginTop: "0px"}} className="transitionloaderwrapper">
          <LinearProgress sx={{ margin: "0px",backgroundColor:"#d10001" }} />
        </div>
      </div>
    );
  } else return null;
};